import React from 'react';
import VersionScopedBase from '../../../../../../Base/VersionScopedBase.mjs';

/**
 * Use `Base` as the root component of the loop system.
 */
const Base = ({ brand, children }) => (React.createElement(VersionScopedBase, null,
    React.createElement("div", { className: `lc${brand ? ` lc-${brand}` : ''}` }, children)));

export { Base };
//# sourceMappingURL=Base.mjs.map
